import { get } from 'lodash';
import { prepareSearchData, SORT_DESC } from '../helpers/prepareSearchData';
import { apiClient, handleError } from '../api/ApiClient';

import {
  SEARCH_INVOICES,
  SEARCH_INVOICES_FAILURE,
  SEARCH_INVOICES_SUCCESS,
} from './InvoicesReducer';

const INVOICE_ENDPOINT = '/invoice';

export const searchInvoices = (values) => (dispatch) => {
  const preparedValues = {
    ...values,
    amountInPenceFrom:
      values?.amountInPenceFrom !== '' && values?.amountInPenceFrom != null
        ? String(Math.round(Number(values.amountInPenceFrom) * 100))
        : '',
    amountInPenceTo:
      values?.amountInPenceTo !== '' && values?.amountInPenceTo != null
        ? String(Math.round(Number(values.amountInPenceTo) * 100))
        : '',
  };

  return apiClient
    .post(
      `${INVOICE_ENDPOINT}/search`,
      prepareSearchData(preparedValues, { createdOn: SORT_DESC }),
    )
    .then((res) => {
      dispatch({ type: SEARCH_INVOICES });
      if (res.status === 200) {
        dispatch({
          type: SEARCH_INVOICES_SUCCESS,
          payload: {
            items: get(res, 'data.data.content', []),
            totalItems: get(res, 'data.data.totalElements', 0),
          },
        });
      }
    })
    .catch((err) => {
      dispatch(handleError(err));
      dispatch({ type: SEARCH_INVOICES_FAILURE });
    });
};

export const getInvoice = (invoiceId) => () =>
  apiClient.get(`${INVOICE_ENDPOINT}/${invoiceId}`).then((res) => get(res, 'data.data'));

export const downloadInvoicePDF = (invoiceId) => (dispatch) =>
  apiClient
    .get(`${INVOICE_ENDPOINT}/${invoiceId}/download`, { responseType: 'blob' })
    .then((res) => {
      if (res.status === 200) {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `invoice-${invoiceId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      }
    })
    .catch((err) => {
      dispatch(handleError(err));
    });

export const downloadInvoiceCreditNote = (invoiceId) => (dispatch) =>
  apiClient
    .get(`${INVOICE_ENDPOINT}/${invoiceId}/credit-note/download`, { responseType: 'blob' })
    .then((res) => {
      if (res.status === 200) {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `credit-note.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      }
    })
    .catch((err) => {
      dispatch(handleError(err));
    });

export const updateInvoice = (invoiceId, body) => (dispatch) =>
  apiClient
    .put(`${INVOICE_ENDPOINT}/${invoiceId}`, body)
    .then((res) => get(res, 'data.data'))
    .catch((err) => {
      dispatch(handleError(err));
      throw err;
    });

export const getInvoiceTransactions = (invoiceId) => (dispatch) =>
  apiClient
    .post(`${INVOICE_ENDPOINT}/${invoiceId}/transactions/search`)
    .then((res) => get(res, 'data.data', []))
    .catch((err) => {
      dispatch(handleError(err));
      throw err;
    });
